export const pillars = ['Client Briefs', 'Project Scope', 'Deliverables', 'Proposal Writing', 'Value Presentation', 'Quality Control'];
export const volumes = [{
  n: 1,
  title: 'The Client Brief Decoder™',
  desc: 'Turn scattered client information into a clearer project brief. Identify objectives, summarize requirements, uncover missing information, and prepare relevant discovery questions.'
}, {
  n: 2,
  title: 'The Scope & Deliverables Blueprint™',
  desc: 'Define project deliverables, boundaries, assumptions, revision expectations, client responsibilities, and dependencies before committing to the work.'
}, {
  n: 3,
  title: 'The Proposal Architect™',
  desc: 'Build a structured proposal with a project overview, objectives, proposed approach, deliverables, timeline considerations, responsibilities, and next steps.'
}, {
  n: 4,
  title: 'The Value Presentation Playbook™',
  desc: "Communicate the value of your proposed work more clearly. Connect your services to the client's stated needs and explain your recommendations without exaggerated promises."
}, {
  n: 5,
  title: 'The Proposal Polish System™',
  desc: 'Review your proposal for missing information, unclear language, inconsistent scope, unsupported assumptions, and sections that need improvement.'
}, {
  n: 6,
  title: 'The Client Handoff Blueprint™',
  desc: 'Prepare approval steps, client information requests, onboarding communications, initial task lists, and kickoff agendas for a more organized project start.'
}];
export const volumeIncludes = ['Step-by-step AI prompts ready to customize', 'Clearly marked input fields for your project information', 'Instructions explaining when to use each prompt', 'Expected output guidance', 'Practical tips for improving the results', 'Review and quality-control checklists'];
export const bonuses = [{
  n: '01',
  title: 'The Freelance Proposal Template Vault™',
  tagline: 'Ready-to-Customize Proposal Frameworks for Freelancers',
  desc: 'Start with organized proposal frameworks instead of building every document from a blank page. Adapt the structure to your service, client, and project requirements.',
  price: '$32',
  cover: 'https://cdn.magicpatterns.com/uploads/7cWzkkCufPDCy9PYCLU7XL/Checklist_de_Alcance_del_Proyecto_(2).webp'
}, {
  n: '02',
  title: 'The Client Follow-Up Message Vault™',
  tagline: '100+ Professional Messages to Reconnect, Follow Up & Move Client Conversations Forward',
  desc: 'Prepare adaptable messages for unanswered proposals, client inquiries, project updates, and other common communication situations.',
  price: '$29',
  cover: 'https://cdn.magicpatterns.com/uploads/uhq212GmkzdULyMsyKZgd3/Checklist_de_Alcance_del_Proyecto_(4).webp'
}, {
  n: '03',
  title: 'The Project Scope Checklist Pack™',
  tagline: "The Freelancer's Toolkit for Defining Deliverables, Setting Boundaries & Preventing Scope Creep",
  desc: 'Use practical checklists to review requirements, clarify deliverables, establish responsibilities, and identify scope details that should be discussed before work begins.',
  price: '$32',
  cover: 'https://cdn.magicpatterns.com/uploads/sGpegj1ZyJNW93qb4bhe9f/Checklist_de_Alcance_del_Proyecto.webp'
}, {
  n: '04',
  title: 'The Client Discovery Question Bank™',
  tagline: '120 Strategic Questions to Understand Client Needs, Qualify Projects & Define Requirements',
  desc: 'Ask more relevant questions to understand client objectives, priorities, constraints, expectations, and project requirements before preparing your proposal.',
  price: '$27',
  cover: 'https://cdn.magicpatterns.com/uploads/cUVzqwmy5T7UrCA7vy6FHj/Checklist_de_Alcance_del_Proyecto_(3).webp'
}, {
  n: '05',
  title: 'The 7-Day Proposal Workflow Quick-Start™',
  tagline: 'A Practical 7-Day Action Plan to Build a Repeatable Freelance Proposal Process',
  desc: 'Follow a structured seven-day plan to organize your materials, customize your prompts, establish your workflow, and begin applying the system to your freelance business.',
  price: '$27',
  cover: 'https://cdn.magicpatterns.com/uploads/jLP3bjA7erJQWy3HhxPkTd/Checklist_de_Alcance_del_Proyecto_(1).webp'
}];
